import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleRight, faAngleLeft, faQuestionCircle } from '@fortawesome/pro-duotone-svg-icons'
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import { getSlugDataAsync } from "./api/slugApi";
import 'whatwg-fetch'

Sentry.init({
    Vue,
    dsn: "https://20b5a6d9b3f2492baec7be6cd5aa6688@o354249.ingest.sentry.io/5543323",
    integrations: [
      new Integrations.BrowserTracing(),
    ],
  
    tracesSampleRate: 0.1,
  });

library.add(faAngleRight, faAngleLeft, faQuestionCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)

new Vue({
    data: {
      slugData: {},
      slug: null
    },
    watch: {
      async slug(slug) {
        if(!slug) {
          window.location.href = "404.html";
          return;
        } else {
          try {
            this.$set(this, 'slugData', await getSlugDataAsync(slug))
          } catch {
            window.location.href = "404.html";
            return;
          }
        }
      }
    },
    created() {
      if (window.location.hash) {
        this.slug = window.location.hash.slice(1).replace("/", "");
      } else if (process.env.NODE_ENV !== "development") {
        this.slug = false;
      } else {
        this.slug = "teo/demo";
      }

      window.addEventListener('hashchange', function() {
        location.reload();
      }, false);
    },
    render: h => h(App),
}).$mount('#app')